import { useState } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { NavTabs } from '@components/NavTabs';
import { useTranslation } from '@hooks';
import { RoutePath } from '@constants/routes';
import Reviews from './Reviews';
import KeywordsPage from '@pages/KeywordsPage';

const Container = styled('div')({
    '@media (max-width: 1024px)': {
        padding: '16px 16px 0',
        height: 'calc(var(--100vh) - 108px)',
        overflowY: 'auto',
    },
    '@media print': {
        height: 'auto',
        overflow: 'visible',
    },
});

const StyledNavTabs = styled(NavTabs)({
    '@media print': {
        display: 'none',
    },
});

const AnalyticsReviewsRoute = () => {
    const { pathname } = useLocation();
    const [currentTab, setCurrentTab] = useState(pathname);
    const { t } = useTranslation();

    const availableTabs = [
        { label: t('Sidebar.analyticsReviews'), value: RoutePath.ReviewsAnalyticsReviews },
        { label: t('Sidebar.keywords'), value: RoutePath.ReviewsAnalyticsKeywords },
    ];

    const RouteMap = {
        [RoutePath.ReviewsAnalyticsReviews]: 0,
        [RoutePath.ReviewsAnalyticsKeywords]: 1,
    };

    return (
        <Container>
            <StyledNavTabs
                tabLinks={availableTabs}
                onTabClick={selectedTab => setCurrentTab(selectedTab)}
                currentTabIndex={RouteMap[currentTab]}
            />
            <Switch>
                <Route path={RoutePath.ReviewsAnalyticsReviews} component={Reviews} />
                <Route path={RoutePath.ReviewsAnalyticsKeywords} component={KeywordsPage} />
                <Redirect from={RoutePath.ReviewsAnalytics} to={RoutePath.ReviewsAnalyticsReviews} />
            </Switch>
        </Container>
    );
};

export default AnalyticsReviewsRoute;
